import { render, staticRenderFns } from "./DataTables.vue?vue&type=template&id=8d9cb4aa"
import script from "./DataTables.vue?vue&type=script&lang=js"
export * from "./DataTables.vue?vue&type=script&lang=js"
import style0 from "./DataTables.vue?vue&type=style&index=0&id=8d9cb4aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports